import styled from 'styled-components';
import { Body5, Container } from '@ui';
import React from 'react';

const ReportingPeriodWrapper = styled.div`
  width: 140px;
  padding: 0 8px 0 0;
`;
const ReportingPeriodLabel = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.text};
    font-size: 12px;
  }
`;
const ReportingPeriodSelect = styled.select`
  width: 100%;
  padding: 8px;
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 6px;
`;

export const REPORTING_PERIOD_AVAILABLE_TYPES = ['quarter', 'month', 'year'];

const convertToQuarterName = (quarter) => {
  if (quarter === 1) return 'Q1';
  if (quarter === 2) return 'Q2';
  if (quarter === 3) return 'Q3';
  if (quarter === 4) return 'Q4';
  return null;
};

const convertToMonthName = (month) => {
  if (month === 1) return 'Jan';
  if (month === 2) return 'Feb';
  if (month === 3) return 'Mar';
  if (month === 4) return 'Apr';
  if (month === 5) return 'May';
  if (month === 6) return 'Jun';
  if (month === 7) return 'Jul';
  if (month === 8) return 'Aug';
  if (month === 9) return 'Sep';
  if (month === 10) return 'Oct';
  if (month === 11) return 'Nov';
  if (month === 12) return 'Dec';
  return null;
};

export const ReportingPeriodFilter = ({ reportingPeriodType, value, options, onChange }) => {
  const handleChange = (e) => {
    onChange(reportingPeriodType, e.target.value);
  };
  if (reportingPeriodType === 'quarter') {
    return (
      <ReportingPeriodWrapper>
        <ReportingPeriodLabel>
          <Body5>Quarter</Body5>
        </ReportingPeriodLabel>

        <Container top={4}>
          <ReportingPeriodSelect value={value} onChange={handleChange}>
            <option value="">All</option>
            {options.map((option) => (
              <option key={option} value={option}>
                {convertToQuarterName(option)}
              </option>
            ))}
          </ReportingPeriodSelect>
        </Container>
      </ReportingPeriodWrapper>
    );
  }
  if (reportingPeriodType === 'month') {
    return (
      <ReportingPeriodWrapper>
        <ReportingPeriodLabel>
          <Body5>Month</Body5>
        </ReportingPeriodLabel>
        <Container top={4}>
          <ReportingPeriodSelect value={value} onChange={handleChange}>
            <option value="">All</option>
            {options.map((option) => (
              <option key={option} value={option}>
                {convertToMonthName(option)}
              </option>
            ))}
          </ReportingPeriodSelect>
        </Container>
      </ReportingPeriodWrapper>
    );
  }
  if (reportingPeriodType === 'year') {
    return (
      <ReportingPeriodWrapper>
        <ReportingPeriodLabel>
          <Body5>Year</Body5>
        </ReportingPeriodLabel>
        <Container top={4}>
          <ReportingPeriodSelect value={value} onChange={handleChange}>
            <option value="">All</option>
            {options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ReportingPeriodSelect>
        </Container>
      </ReportingPeriodWrapper>
    );
  }
  return null;
};

export const assembleReportingPeriodTypes = (docs) => {
  const result = {
    quarter: [],
    month: [],
    year: [],
  };

  if (!Array.isArray(docs)) return result;

  docs.forEach((doc) => {
    if (
      doc.fiscal_quarter !== undefined &&
      doc.fiscal_quarter !== null &&
      !result.quarter.includes(doc.fiscal_quarter)
    ) {
      result.quarter.push(doc.fiscal_quarter);
    }
    if (doc.fiscal_month !== undefined && doc.fiscal_month !== null && !result.month.includes(doc.fiscal_month)) {
      result.month.push(doc.fiscal_month);
    }
    if (doc.fiscal_year !== undefined && doc.fiscal_year !== null && !result.year.includes(doc.fiscal_year)) {
      result.year.push(doc.fiscal_year);
    }
  });

  return result;
};
